import { CognitoKey, UserType, USER_GROUP_OPTIONS, USER_TYPE_GROUPS } from './userGroups';

export interface UserTypeResult {
  userType: UserType | null;
  isConsistent: boolean;
}

export function determineUserTypeFromGroups(groups: string[]): UserTypeResult {
  const hasSuperAdmin = groups.some(g => g.includes(CognitoKey.SuperAdmins));
  const hasLocalSetupClient = groups.some(g => g.includes(CognitoKey.LocalSetupClientUsers));
  const hasLocalClientUser = groups.some(g => g.includes(CognitoKey.LocalClientUsers));
  const hasSkyTeamMember = groups.some(g => g.includes(CognitoKey.SkyTeamMembers));
  const hasImageryTeamMember = groups.some(g => g.includes(CognitoKey.ImageryTeamMembers));
  const hasOrgUser = groups.some(g => g.includes(CognitoKey.OrgUsers));

  // Tech: has all three groups
  if (hasSuperAdmin && hasLocalSetupClient && hasLocalClientUser) {
    const expectedCount = USER_TYPE_GROUPS[UserType.Tech].length;
    return { userType: UserType.Tech, isConsistent: groups.length === expectedCount };
  }

  // Imagery: has imagery group
  if (hasImageryTeamMember) {
    const expectedCount = USER_TYPE_GROUPS[UserType.Imagery].length;
    return { userType: UserType.Imagery, isConsistent: groups.length === expectedCount };
  }

  // SkyTeam: has skyTeam group
  if (hasSkyTeamMember) {
    const expectedCount = USER_TYPE_GROUPS[UserType.SkyTeam].length;
    return { userType: UserType.SkyTeam, isConsistent: groups.length === expectedCount };
  }

  // Client: has orgUser group
  if (hasOrgUser) {
    return { userType: UserType.Client, isConsistent: groups.length === 1 };
  }

  return { userType: null, isConsistent: false };
}

export function getGroupsForUserType(userType: UserType, env: any): string[] {
  const cognitoKeys = USER_TYPE_GROUPS[userType];
  return cognitoKeys
    .map(key => env.cognitoGroups[key])
    .filter(Boolean);
}

export function parseGroupToDisplayName(cognitoGroup: string): string | null {
  const option = USER_GROUP_OPTIONS.find(o => cognitoGroup.includes(o.cognitoKey));
  return option ? option.displayName : null;
}
